import { Component, OnDestroy, OnInit } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '../../../custom-function.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
	selector: 'app-validatorqueue',
	templateUrl: './validatorqueue.component.html',
	styleUrls: ['./validatorqueue.component.scss'],
})
export class ValidatorqueueComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private apiService: LegacyApiService,
		private customFunction: CustomFunctionService,
		private http: HttpClient,
		private _routerLink: Router,
		private store: Store<State>
	) {}

	timestamp = Date();

	// Overall
	creditArray: [];
	underwritingCompleteArray: [];

	totalCredit: any;
	totalUC: any;
	totalCBAmount: any;
	totalUCAmount: any;

	ngOnInit(): void {
		this.store.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.fetchUnderwritingCB();
					this.getUnderwritingComplateValidator();

					(<HTMLImageElement>document.querySelector('#ooma')).src =
						'https://manage.voxter.com/#';
				}
			});
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	fetchUnderwritingCB() {
		this.apiService.getDealsCreatedUnderwritingCB().subscribe((res) => {
			if (res.message.statusCode === 200) {
				let arr = JSON.parse(res.message.body);
				this.creditArray = arr.data;
				this.totalCredit = this.creditArray.length;
				this.totalCBAmount = this.customFunction
					.sumNumbers(this.creditArray, 'Amount')
					.toFixed(2);
			} else {
				this.creditArray = [];
				this.totalCredit = 0;
				this.totalCBAmount = 0;
			}
		});
	}

	getUnderwritingComplateValidator() {
		this.apiService.getUnderwritingComplateValidator().subscribe((res) => {
			console.log(res);
			if (res.message.statusCode === 200) {
				let arr = JSON.parse(res.message.body);
				this.underwritingCompleteArray = arr.data;
				this.totalUC = this.underwritingCompleteArray.length;
				this.totalUCAmount = this.customFunction
					.sumNumbers(this.underwritingCompleteArray, 'Amount')
					.toFixed(2);
			} else {
				this.underwritingCompleteArray = [];
				this.totalUC = 0;
				this.totalUCAmount = 0;
			}
		});
	}

	// Window Refresh
	refresh() {
		window.location.reload();
		// setTimeout(function() {
		//   location.reload();
		// }, 120000);
	}
}
